import { useListContext } from 'react-admin';
import { useLocation, useNavigate } from 'react-router-dom';
import { buildFilterSearch } from 'shared/mui/Filter/utils/buildFilterSearch';

export function useApplyFiltersToUrl() {
  const { displayedFilters, sort, page, perPage } = useListContext();
  const location = useLocation();
  const navigate = useNavigate();

  const applyFiltersToUrl = (appliedFilters: Record<string, any>) => {
    navigate(
      {
        search: buildFilterSearch(location.search, appliedFilters, {
          displayedFilters,
          sort,
          page,
          perPage,
        }),
      },
      { replace: true },
    );
  };

  return { applyFiltersToUrl };
}
